<!-- 物业管理 -->
<style lang="scss" scoped>
.index {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  .canotClick {
    pointer-events: none !important;
  }
  .top-back {
    width: 1064px;
    height: 35px;
    left: 414px;
    top: 44px;
    position: absolute;
    background: linear-gradient(221deg, transparent 20px, #46464654 0);
    display: flex;
    padding-left: 6px;
    pointer-events: all;
    .tab-item {
      width: 96px;
      height: 35px;
      margin-right: 8px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      line-height: 26px;
      letter-spacing: 0.1em;
      color: #afafaf;
      border-top: 4px solid transparent;
    }
    .selectRoute {
      border-top: 4px solid #ffffff;
      color: #ffffff;
      background-image: url("../../assets/public/tab-select.png");
      background-size: cover;
    }
    .disableClass {
      pointer-events: none;
    }
  }
  .child-tab {
    width: 458px;
    height: 38px;
    left: 469px;
    top: 82px;
    position: absolute;
    display: flex;
    pointer-events: all;
    .child-item {
      font-size: 18px;
      letter-spacing: 0.1em;
      color: #afafaf;
      margin-right: 4px;
      padding: 2px 13px;
      white-space: nowrap;
      cursor: pointer;
    }
    .child-select {
      background-image: url("../../assets/public/child-select.png");
      background-size: 100% 100%;
      color: #ffffff;
    }
  }
  .jinyongColor {
    color: #afafaf5b !important;
  }
  .pannel {
    position: absolute;
    left: 682px;
    top: 858px;
    cursor: pointer;
    pointer-events: all;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      background: rgba(255, 255, 255, 0.08);
      backdrop-filter: blur(5px);
      z-index: -1;
    }
  }
}
.tieTu {
  width: 207px;
  height: 123px;
  position: absolute;
  z-index: 3;
  opacity: 0;
  background-image: url("../../assets/public/floorDialog.png");
  background-size: cover;
  display: flex;
  align-items: center;
  .tt_box {
    width: 162px;
    height: 102px;
    display: grid;
    grid-template-columns: repeat(2, 76px);
    gap: 6px 10px;
    color: #fff;
    margin-left: 23px;
    .item {
      p:nth-child(1) {
        font-size: 14px;
        font-family: "source";
        width: 56px;
        height: 20px;
        line-height: 20px;
      }
      p:nth-child(2) {
        font-size: 24px;
        font-weight: 700;
        font-family: "dina";
        color: #2d82ff;
        width: 76px;
        height: 28px;
        line-height: 28px;
      }
    }
    .item:nth-child(3) {
      p:nth-child(2) {
        color: #fff;
      }
    }
    .item:nth-child(4) {
      p:nth-child(2) {
        color: #f1802f;
      }
    }
  }
}
.show {
  opacity: 1 !important;
}
</style>

<template>
  <div class="index">
    <custom-decorate v-if="$route.name == 'propertyPage'"></custom-decorate>
    <custom-dereturn @returnEvent="returnEvent" v-else></custom-dereturn>
    <div class="top-back" :class="canClick ? '' : 'canotClick'">
      <div
        class="tab-item"
        v-for="(item, index) in menuData"
        :key="`tab${index}`"
        :class="{
          selectRoute: getNowRouteInfo.includes(item.name),
          disableClass: !$store.state.isDisabled,
          jinyongColor: item.isClick,
        }"
        @click="
          toRouterDetial(item.toRouterName, item.toRouterPath, item.isClick)
        "
      >
        {{ item.name }}
      </div>
    </div>
    <div
      class="child-tab"
      v-if="getRouteChild"
      :class="canClick ? '' : 'canotClick'"
    >
      <div
        class="child-item"
        v-for="(item, index) in getRouteChild"
        :key="`child${index}`"
        @click="toChild(item.toRouterName, item.toRouterPath, item.isClick)"
        :class="{
          'child-select': getNowRouteInfo.includes(item.name),
          disableClass: !$store.state.isDisabled,
          jinyongColor: item.isClick,
        }"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="pannel" v-if="$route.name != 'tenth'" @click="toWarnPage">
      <WarnPannel :warnPannelData="warnPannelData"></WarnPannel>
    </div>
    <router-view></router-view>
    <div class="tieTu">
      <div class="tt_box">
        <div class="item" v-for="(item, key, index) in itemList" :key="index">
          <p>{{ item }}</p>
          <p>{{ resList[key] }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bus from "@/components/three-scene/Bus.js";
import WarnPannel from "./components/warn-pannel.vue";
import {
  getHomePageData,
  getParkData,
  getElevatorData,
  getAlarmDataHistorical,
  getEqpStatus,
  getEqpStatusByBuildNo,
} from "@/api";
export default {
  data() {
    return {
      timer: null,
      socket: "",
      itemList: {
        total: "总设备量",
        normal: "正常数量",
        standby: "待机数量",
        fault: "故障数量",
      },
      resList: {},
      canClick: true,
      menuData: [
        {
          name: "环境监测",
          toRouterName: "second",
          toRouterPath: "environment",
        },
        {
          name: "能耗管理",
          toRouterName: "third",
          toRouterPath: "energy",
          children: [
            {
              name: "水能耗",
              toRouterName: "third-first",
              toRouterPath: "waterCons",
            },
            // {
            //   name: "气能耗",
            //   toRouterName: "third-second",
            //   toRouterPath: "gasCons",
            // },
            {
              name: "电能耗",
              toRouterName: "third-third",
              toRouterPath: "eleCons",
            },
            // {
            //   name: "照明电",
            //   toRouterName: "third-fourth",
            //   toRouterPath: "illuminaEle",
            // },
            // {
            //   name: "动力电",
            //   toRouterName: "third-fifth",
            //   toRouterPath: "powerEle",
            // },
            // {
            //   name: "空调电",
            //   toRouterName: "third-sixth",
            //   toRouterPath: "airEle",
            // },
          ],
        },
        {
          name: "设备运维",
          toRouterName: "fourth",
          toRouterPath: "facility",
          children: [
            {
              name: "变配电",
              toRouterName: "fourth-first",
              toRouterPath: "eletransfrom",
            },
            {
              name: "给排水",
              toRouterName: "fourth-second",
              toRouterPath: "watersupply",
            },
            {
              name: "照明",
              toRouterName: "fourth-third",
              toRouterPath: "equillumina",
            },
            {
              name: "消防",
              toRouterName: "fourth-fourth",
              toRouterPath: "firecontrol",
            },
            // {
            //   name: "安防",
            //   toRouterName: "fourth-fifth",
            //   toRouterPath: "security",
            // },
            {
              name: "空调",
              toRouterName: "fourth-sixth",
              toRouterPath: "aircondition",
            },
            {
              name: "电梯",
              toRouterName: "fourth-seventh",
              toRouterPath: "equelevator",
            },
            {
              name: "网关",
              toRouterName: "fourth-eighth",
              toRouterPath: "gateway",
            },
          ],
        },
        { name: "停车管理", toRouterName: "fifth", toRouterPath: "park" },
        { name: "告警中心", toRouterName: "tenth", toRouterPath: "warin" },
        {
          name: "监控中心",
          toRouterName: "first",
          toRouterPath: "monitoring",
          // isClick: true,
        },
        {
          name: "巡更管理",
          toRouterName: "sixth",
          toRouterPath: "keepwatch",
          isClick: true,
        },
        {
          name: "物业通知",
          toRouterName: "seventh",
          toRouterPath: "porinform",
          isClick: true,
        },
        {
          name: "访客管理",
          toRouterName: "eighth",
          toRouterPath: "visitor",
          isClick: true,
        },
        {
          name: "在线缴费",
          toRouterName: "ninth",
          toRouterPath: "pay",
          isClick: true,
        },
      ],
      warnPannelData: [],
      headerMap: {
        A1: "01",
        A2: "02",
        B1B2: "03",
        B3: "04",
      },
      maps: {
        "fourth-fourth": "XF",
        second: "HJ",
        "third-first": "WM",
        "fourth-sixth": "KT",
        "fourth-eighth": "WG",
        "third-third": "GD",
        first: "AF",
      },
    };
  },
  mounted() {
    bus.emit("to2Dui", "tieTu");
    bus.on("getClickBuild", (name) => {
      let needName = [
        "third-first",
        "third-third",
        "fourth-sixth",
        "fourth-eighth",
      ];
      if (needName.includes(this.$route.name)) {
        bus.emit("setName", name);
        console.log(name,'ss');
      }
      // 楼层显示对应弹框
      if (this.maps[this.$route.name] && this.headerMap[name]) {
        this.ReqEqpStatusByBuildNo({
          module: this.maps[this.$route.name],
          buildNo: this.headerMap[name],
        });
      }
    });
    bus.on("dialogClose", () => {});
    bus.on("pdjd", (name) => {
      if (this.$route.name == "fourth-first") {
        bus.emit("pdjd1", name);
      }
    });
    bus.on("pdja", (name) => {
      if (this.$route.name == "fourth-first") {
        bus.emit("pdja1", name);
      }
    });
    bus.on("closepdja", () => {
      if (this.$route.name == "fourth-first") {
        bus.emit("closepdja1");
      }
    });
    bus.on("getPointState", this.getEqpStatus);
    this.giveParkingUsed();
    this.giveLiftData();
  },
  computed: {
    getNowRouteInfo() {
      return this.$route.meta.name;
    },
    getRouteChild() {
      for (let item of this.menuData) {
        if (this.getNowRouteInfo.includes(item.name)) {
          return item.children;
        }
      }
      return;
    },
  },
  created() {
    bus.on("canClick", this.changeClickStatus);
      this.getAlarmData();
    this.initWebSocket();
  },
  methods: {
    initWebSocket() {
      this.socket = new WebSocket("ws://124.71.161.213:8081/websocket");
      this.socket.onmessage = this.getMessage;
      this.socket.onerror = this.error;
      this.socket.onclose = this.close;
    },
    getMessage(e) {
      if (e.data == "链接成功") return;
      let res = JSON.parse(e.data);
      this.warnPannelData = [];
      for (let index in res.alarmList) {
        if (index > 2) return;
        this.warnPannelData.push(res.alarmList[index]);
      }
    },
    error(e) {
      console.log("连接错误", e);
    },
    close() {
      console.log("socket已经关闭");
    },
    async getEqpStatus(buildNo, floor) {
      let map = {
        "fourth-fourth": "XF",
        second: "HJ",
        "third-first": "WM",
        "fourth-sixth": "KT",
        "fourth-eighth": "WG",
        "third-third": "GD",
        first: "AF",
      };
      if (this.$route.name == "second" && floor == "B01" && buildNo == "08") {
        bus.emit("closeHJUI");
        let psData = await this.getEqpStatusApi(buildNo, floor, "PS");
        let hjData = await this.getEqpStatusApi(
          buildNo,
          floor,
          map[this.$route.name]
        );
        let res = {
          beyondAlarm: [...psData.beyondAlarm, ...hjData.beyondAlarm],
          fault: [...psData.fault, ...hjData.fault],
          normal: [...psData.normal, ...hjData.normal],
          standby: [...psData.standby, ...hjData.standby],
        };
        console.log(res);
        return res;
      }
      let result = await this.getEqpStatusApi(
        buildNo,
        floor,
        map[this.$route.name]
      );
      return result;
    },
    async getEqpStatusApi(buildNo, floor, module) {
      let { data: res } = await getEqpStatus({
        buildNo,
        floor,
        module,
      });
      return res;
    },
    async getAlarmData() {
      let sendParams = {
        size: 3,
        page: 1,
        status: 0,
      };
      let { data: res } = await getAlarmDataHistorical(sendParams);
      this.warnPannelData = res.records;
    },
    changeClickStatus(status) {
      this.canClick = status;
    },
    async giveLiftData() {
      let { data: res } = await getElevatorData();
      bus.emit("getLiftNumber", res.collectionValue);
    },
    async giveParkingUsed() {
      let { data: res } = await getParkData();
      if (res) {
        let { used } = res;
        bus.emit("getCarPoint", used);
      }
    },
    toWarnPage() {
      this.$router.push({ name: "tenth" });
    },
    returnEvent() {
      if (this.$route.path === "/property") {
        this.$router.push({ name: "index" });
      } else {
        this.$router.push({ name: this.$route.matched.at(-1).parent.name });
      }
    },
    toRouterDetial(name, path, isClick) {
      if (name === this.$route.name) return;
      // let cannotClick = ["first", "sixth", "seventh", "eighth", "ninth"];
      if (isClick) return;
      this.$router.push({ name });
      if (name === "fifth") return;
    },
    toChild(name, path, isClick) {
      if (name === this.$route.name) return;
      // let cannotClick = ["fourth-third"];
      if (isClick) return;
      if (name === "fourth-second" || name === "fourth-seventh") {
        this.$router.push({ name });
      } else if (name === "fourth-fourth") {
        this.$router.push({ name, path, params: { id: 0 } });
      } else {
        this.$router.push({ name });
      }
    },
    async ReqEqpStatusByBuildNo(params) {
      let { data: res } = await getEqpStatusByBuildNo(params);
      this.resList = res;
      res.total = res.standby + res.fault + res.normal;
    },
  },
  components: { WarnPannel },
};
</script>
